export default __webpack_public_path__ + "static/media/close.04464726.svg";